import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "block p-4 bg-white border border-gray-200 rounded-lg shadow hover:border-[rgb(var(--v-theme-primary))] at-rate-card"
};
const _hoisted_2 = {
  class: "flex flex-row justify-between"
};
const _hoisted_3 = {
  class: "mb-2 text-lg font-bold tracking-tight text-gray-900 dark:text-white"
};
const _hoisted_4 = {
  class: "text-green-regular at-rate-card-default"
};
const _hoisted_5 = {
  class: "cursor-pointer"
};
const _hoisted_6 = {
  class: "flex flex-row justify-between"
};
const _hoisted_7 = {
  class: "font-normal text-gray-700 dark:text-gray-400"
};
const _hoisted_8 = {
  class: "font-normal text-gray-700 dark:text-gray-400"
};
export default {
  __name: 'RateCard',
  props: {
    rateGroup: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_createTextVNode(_toDisplayString(__props.rateGroup.name) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_4, "(Default)", 512), [[_vShow, __props.rateGroup.default]])]), _createElementVNode("p", _hoisted_5, [(_openBlock(), _createElementBlock("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('openMenu', __props.rateGroup), ["stop"]))
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("g", {
        "clip-path": "url(#clip0_7097_13833)"
      }, [_createElementVNode("path", {
        d: "M5.00016 8.33301C4.0835 8.33301 3.3335 9.08301 3.3335 9.99967C3.3335 10.9163 4.0835 11.6663 5.00016 11.6663C5.91683 11.6663 6.66683 10.9163 6.66683 9.99967C6.66683 9.08301 5.91683 8.33301 5.00016 8.33301ZM15.0002 8.33301C14.0835 8.33301 13.3335 9.08301 13.3335 9.99967C13.3335 10.9163 14.0835 11.6663 15.0002 11.6663C15.9168 11.6663 16.6668 10.9163 16.6668 9.99967C16.6668 9.08301 15.9168 8.33301 15.0002 8.33301ZM10.0002 8.33301C9.0835 8.33301 8.3335 9.08301 8.3335 9.99967C8.3335 10.9163 9.0835 11.6663 10.0002 11.6663C10.9168 11.6663 11.6668 10.9163 11.6668 9.99967C11.6668 9.08301 10.9168 8.33301 10.0002 8.33301Z",
        fill: "#787579"
      })], -1), _createElementVNode("defs", null, [_createElementVNode("clipPath", {
        id: "clip0_7097_13833"
      }, [_createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "white"
      })])], -1)]))]))])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(__props.rateGroup.description), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(__props.rateGroup.mattersCount || 0) + " Matters ", 1)])]);
    };
  }
};